
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[article]",
      function () {
        return require("private-next-pages/[article].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[article]"])
      });
    }
  